import { Bar, mixins } from "vue-chartjs"
import numeral from "numeral"

export default Bar.extend({
    mixins: [mixins.reactiveProp],
    props: {
        chartData: {
            type: Array | Object,
            required: false
        },
        legendPosition: {
            type: String,
            default: "right"
        },
        displayMode: {
            type: String,
            required: false
        },
        units: {
            type: String,
            required: false
        },
        yMax: {
            type: Number,
            default: 0
        }
    },
    watch: {
        displayMode: "rerender",
        legendPosition: "rerender",
        yMax: "rerender"
    },
    methods: {
        rerender () {
            this._chart.destroy()
            this.renderChart(this.chartData, this.options)
        },
        value_as_string (value) {
            if(this.displayMode === "relative") return numeral(value).format("0,0") + "%"
            const value_numeral = numeral(value)
            if(this.units === "total") {
                if(value >= 100000) return `$ ${numeral(value / 1000000).format("0,0.0")}M`
                if(value >= 1000) return `$ ${numeral(value / 1000).format("0,0.0")}K`
                return `$ ${value_numeral.format("0,0")}`
            }
            return `${value_numeral.format("0,0")}`
        }
    },
    computed: {
        options () {
            const ticks = {
                beginAtZero: true,
                fontColor: "#00274F",
                callback: (value, index, values) => {
                    return this.value_as_string(value)
                }
            }
            if(this.displayMode === "relative") ticks.max = 100
            if(this.displayMode === "absolute") {
                // ticks.max = this.yMax
                ticks.suggestedMax = this.yMax
            }
            return {
                tooltips: {
                    callbacks: {
                        label: (tooltipItem, data) => {
                            return `${data.datasets[tooltipItem.datasetIndex].label}: ${this.value_as_string(parseFloat(tooltipItem.yLabel) || 0)}`
                        }
                    }
                },
                scales: {
                    yAxes: [{
                        stacked: true,
                        ticks,
                        gridLines: {
                            display: true,
                            color: "rgba(0, 39, 79, 0.1)"
                        }
                    }],
                    xAxes: [{
                        stacked: true,
                        gridLines: {
                            display: false,
                            color: "rgba(0, 39, 79, 0.1)"
                        },
                        categoryPercentage: 0.9,
                        barPercentage: 0.8
                    }]
                },
                legend: {
                    display: true,
                    position: this.legendPosition,
                    labels: {
                        fontSize: 11,
                        // fontFamily: "'Helvetica Neue', Helvetica, Arial, 'sans-serif'",
                        fontStyle: "bold",
                        fontColor: "#00274F",
                        boxWidth: 14,
                        padding: 13
                    }
                },
                responsive: true,
                maintainAspectRatio: false
            }
        }
    },
    mounted () {
        this.renderChart(this.chartData, this.options)
    }
})
